import { ListLink } from "@components"

import {
  ChartBarSquareIcon,
  DocumentMagnifyingGlassIcon, 
} from "@heroicons/react/24/outline"

import { VIEWS } from "../data"
import PropTypes from "prop-types"

const MenuItems = ({ handleMenuSelect }) => (
  <div>
    <ListLink 
      title={VIEWS.GUARDIAN_IMPORT_ISSUE_REPORT.title} 
      description={VIEWS.GUARDIAN_IMPORT_ISSUE_REPORT.subTitle} 
      icon={ChartBarSquareIcon} 
      iconColor="text-indigo-800 dark:text-content2-foreground" 
      handleClick={() => handleMenuSelect(VIEWS.GUARDIAN_IMPORT_ISSUE_REPORT)} 
    />
    
    <ListLink 
      title={VIEWS.LAST_IMPORT_REPORT.title} 
      description={VIEWS.LAST_IMPORT_REPORT.subTitle} 
      icon={ChartBarSquareIcon} 
      iconColor="text-indigo-800 dark:text-content2-foreground" 
      handleClick={() => handleMenuSelect(VIEWS.LAST_IMPORT_REPORT)} 
    />

    <ListLink 
      title={VIEWS.META.title} 
      description={VIEWS.META.subTitle} 
      icon={DocumentMagnifyingGlassIcon} 
      iconColor="text-indigo-800 dark:text-content2-foreground" 
      handleClick={() => handleMenuSelect(VIEWS.META)} 
    />
  </div>
)

MenuItems.propTypes = {
  handleMenuSelect: PropTypes.func.isRequired,
}

export default MenuItems